// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/phonetic-alphabet.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/phonetic-alphabet/phonetic-alphabet.js';

mount([g0]);
